/* eslint-disable */
import { cloneDeep } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { analyticsAction, formActions, modalActions, productActions } from '../../../Actions';
import { ViewPageHeader } from '../../../Components/Headers';
import {
	Button,
	Switch,
	FormControlLabel,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TableSortLabel,
	Paper,
	CircularProgress,
} from '@mui/material';
import { notificationServices } from '@/Services';
import {
	StyledTabs,
	StyledTab,
	TabPanel,
} from '../../../Components/StyledTabs';
import { PageNavigation } from '@/Components/Headers/PageNavigation';
import { urls } from '@/Constants';
import { handleExcelDownload, history, inputHelper, isEmpty, keyPressHandler } from '../../../Helpers';
import cookingRecipeConfig, { depthFirstIntermediates, findAllIntermediateProducts, resolveCompareVersion } from './cookingRecipe.config';
import { GeneralDetails } from '../../../Components/Forms/Customizations';
import {
	RecipeDetails,
	// RecipeStage,
} from '../../../Components/Forms/Cooking/Cooking Recipe';
// import { DraggableHTabs } from '../../../Components/Draggable';
// eslint-disable-next-line import/no-unresolved, import/extensions
import CookingRecipeStages from '../../../Components/Cooking/CookingRecipeStages/CookingRecipeStages';
import cookingRecipesServices from '../../../Services/Form Services/cookingRecipes.services';
import excel from '../../../Images/excel.svg';
import ProductCookingConfig from '@/Components/Forms/Products/ProductCookingConfig';
import { cookingConfig } from '@/Pages/Food Products/All Products/cooking.config';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import productProcessMapServices from '../../../Services/Analytics Services/product-process-map.services';

import { MAPPING_TYPE_CONFIG } from './mapping.constants';
import { AlertModal } from '@/Components/Modals';
import useKeyPress from '@/Helpers/useKeyPress';

const TABS = ['RECIPE DETAILS'];

// Drives both the BOM table headers and the sort comparator - 'numeric' picks
// a numeric compare instead of the default string one for qty/cost columns.
const BOM_COLUMNS = [
	{ key: 'productName', label: 'Ingredient Name', numeric: false },
	{ key: 'variantName', label: 'Variant Name', numeric: false },
	{ key: 'qty', label: 'Base Qty', numeric: true },
	{ key: 'adjustedQty', label: 'Adjusted Qty', numeric: true },
	{ key: 'unit', label: 'Unit', numeric: false },
	{ key: 'totalCostPerUnit', label: 'Unit Cost', numeric: true },
	{ key: 'totalCost', label: 'Base Cost', numeric: true },
	{ key: 'adjustedCost', label: 'Adjusted Cost', numeric: true },
];

const CookingRecipeViewPage = (props) => {
	const {
		fetchProduct,
		fetchProducts,
		fetchRecipeList,
		data,
		breadcrumbs,
		processTypes,
		fetchProcessTypesList,
		fetchCookingStations,
		recipeData,
		fetchProductRecipe,
		storesList,
		fetchStoresList,
		batches,
		fetchBatches,
		list = [],
	} = props;

	const [state, setState] = useState({
		activeTab: 0,
		fields: cloneDeep(cookingRecipeConfig.initialState.fields),
	});

	const [isPastVersion, setIsPastVersion] = useState(true);
	const [pastVersionData, setPastVersionData] = useState(null);
	// Serialized past version fields. Declared here (not lower in the body) so it
	// is initialized before the `[id]` reset effect references setPastVersionFields.
	const [pastVersionFields, setPastVersionFields] = useState(null);
	const didAutoFetchPastVersionRef = useRef(false);

	const [activeStage, setActiveStage] = useState(1);
	const [activeProcess, setActiveProcess] = useState(
		state.fields.stages.items[1]?.processes.order.length ?? -1
	);
	const [cookingFields, setCookingFields] = useState({
		fields: cloneDeep(cookingConfig.initialState.fields),
	});
	const [productMappingData, setProductMappingData] = useState([]);
	const [selectedMappingStoreId, setSelectedMappingStoreId] = useState(null);

	const [isBomModalOpen, setIsBomModalOpen] = useState(false);
	const [bomData, setBomData] = useState([]);
	const [isBomLoading, setIsBomLoading] = useState(false);
	const [bomError, setBomError] = useState('');
	const [selectedVariantId, setSelectedVariantId] = useState('');
	const [inputQuantity, setInputQuantity] = useState(1);
	const [bomSort, setBomSort] = useState({ column: null, direction: 'asc' });

	const handleOpenBomModal = async () => {
		setIsBomModalOpen(true);
		setIsBomLoading(true);
		setBomError('');
		setBomData([]);
		setSelectedVariantId('');
		setInputQuantity(1);
		setBomSort({ column: null, direction: 'asc' });

		try {
			const res = await cookingRecipesServices.fetchRecipeBom({
				req: {
					data: {
						storeId: selectedMappingStoreId,
						products: [parseInt(id, 10)],
					},
				},
			});
			// /recipe/ingredient returns a numeric statusCode (200) / status:'Success'
			// envelope — the same shape the /direct sibling endpoint uses. 'SS-001'
			// is a `responseCode` value, never a `statusCode`, so don't test it here.
			if (res && (res.statusCode === 200 || res.status === 'Success' || res.responseCode === 'SS-001')) {
				const data = Array.isArray(res.data) ? res.data : [];
				setBomData(data);
				// Default to the first variant and pre-fill its batch quantity so the
				// table opens showing the base batch (factor 1) without any user input.
				if (data.length > 0) {
					const preferredId = variants?.[0]?.id;
					const defaultRecipe =
						data.find((r) => Number(r.variantId) === Number(preferredId)) || data[0];
					setSelectedVariantId(defaultRecipe.variantId);
					setInputQuantity(Number(defaultRecipe.batchSize) || 1);
				}
			} else {
				setBomError(res?.message || 'Failed to fetch BOM data.');
			}
		} catch (err) {
			console.error(err);
			setBomError('An error occurred while fetching BOM.');
		} finally {
			setIsBomLoading(false);
		}
	};

	// The chips and the export file name have to name a variant the same way.
	const variantLabel = (recipe) => {
		if (!recipe) return '';
		if (recipe.variantName && recipe.variantName !== '-') return recipe.variantName;
		return recipe.variantItemCode || `Variant ${recipe.variantId}`;
	};

	const activeRecipeInfo = useMemo(() => {
		if (!selectedVariantId || bomData.length === 0) return null;
		return bomData.find((r) => Number(r.variantId) === Number(selectedVariantId));
	}, [selectedVariantId, bomData]);

	// The BOM's per-ingredient cost price is always quoted per kg / ltr / count —
	// RecipeDetailsServiceImpl multiplies it by qty/1000 for gram and ml lines. The
	// row's Unit column, though, shows "gram"/"ml" whenever the quantity is under
	// 1000, so the cell has to name the basis or ₹3750/kg reads as ₹3750/gram.
	const costingUnit = (unit) => {
		const u = String(unit ?? '').toLowerCase();
		if (u === 'gram' || u === 'kg') return 'kg';
		if (u === 'ml' || u === 'ltr') return 'ltr';
		return unit || '-';
	};

	const adjustedIngredients = useMemo(() => {
		if (!selectedVariantId || !inputQuantity || bomData.length === 0) return [];
		const activeRecipe = bomData.find((r) => Number(r.variantId) === Number(selectedVariantId));
		if (!activeRecipe) return [];
		const batchSize = Number(activeRecipe.batchSize) || 1;
		const factor = Number(inputQuantity) / batchSize;

		return (activeRecipe.ingredients || []).map((ing) => {
			return {
				...ing,
				adjustedQty: Number(ing.qty) * factor,
				adjustedCost: ing.totalCost ? Number(ing.totalCost) * factor : null,
			};
		});
	}, [selectedVariantId, inputQuantity, bomData]);

	const handleBomSort = (columnKey) => {
		setBomSort((prev) => ({
			column: columnKey,
			direction: prev.column === columnKey && prev.direction === 'asc' ? 'desc' : 'asc',
		}));
	};

	// Sorting is display-only - export and the empty-state check below keep
	// reading adjustedIngredients so the CSV always lists ingredients in BOM order.
	const sortedIngredients = useMemo(() => {
		if (!bomSort.column) return adjustedIngredients;
		const column = BOM_COLUMNS.find((c) => c.key === bomSort.column);
		const dir = bomSort.direction === 'asc' ? 1 : -1;
		return [...adjustedIngredients].sort((a, b) => {
			if (column?.numeric) {
				return (((Number(a[bomSort.column]) || 0) - (Number(b[bomSort.column]) || 0))) * dir;
			}
			const aStr = String(a[bomSort.column] ?? '').toLowerCase();
			const bStr = String(b[bomSort.column] ?? '').toLowerCase();
			return aStr.localeCompare(bStr) * dir;
		});
	}, [adjustedIngredients, bomSort]);

	// Export exactly what the table is showing: the selected variant at the
	// quantity currently entered, not the base batch.
	const handleExportBom = () => {
		if (adjustedIngredients.length === 0) return;

		const headers = [
			'Ingredient Name',
			'Variant Name',
			'Base Qty',
			'Adjusted Qty',
			'Unit',
			'Unit Cost (INR)',
			// The unit cost is quoted per kg / ltr / count while the row's Unit can
			// read "gram"/"ml", so the basis travels as its own column - without it
			// 105.83 against a "gram" row reads as Rs 105.83 per gram.
			'Unit Cost Per',
			'Base Cost (INR)',
			'Adjusted Cost (INR)',
		];

		const rows = adjustedIngredients.map((ing) => {
			return [
				ing.productName ?? '',
				ing.variantName || '-',
				ing.qty ? Number(ing.qty).toFixed(3) : '',
				ing.adjustedQty ? Number(ing.adjustedQty).toFixed(3) : '',
				ing.unit ?? '',
				ing.totalCostPerUnit ? Number(ing.totalCostPerUnit).toFixed(2) : '',
				ing.totalCostPerUnit ? costingUnit(ing.unit) : '',
				ing.totalCost ? Number(ing.totalCost).toFixed(2) : '',
				ing.adjustedCost ? Number(ing.adjustedCost).toFixed(2) : '',
			];
		});

		// The batch context is not in the table, so it rides in the file name -
		// an exported BOM is meaningless without the variant and quantity it was
		// costed at.
		const fileName = [
			'BOM',
			fields?.product?.productName,
			variantLabel(activeRecipeInfo),
			`${inputQuantity}${activeRecipeInfo?.unit ? ` ${activeRecipeInfo.unit}` : ''}`,
			new Date().toISOString().slice(0, 10),
		]
			.filter(Boolean)
			.join('_')
			.replace(/[\\\/:*?"<>|]/g, '-');

		handleExcelDownload(headers, rows, `${fileName}.csv`);
	};

	// Switching variant re-defaults the quantity to that variant's batch size so
	// the table shows the base batch (factor 1) until the user overrides it.
	const handleVariantChange = (variantId) => {
		setSelectedVariantId(variantId);
		const recipe = bomData.find((r) => Number(r.variantId) === Number(variantId));
		setInputQuantity(Number(recipe?.batchSize) || 1);
	};

	const { id } = useRouteMatch().params;
	const { userConfig = {}, appConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const { userRolesDict = {} } = userConfig || {};
	const isDevEnv = appConfig?.customerId === 5;
	const isConfigAdmin = Object?.values(userRolesDict)?.includes('Config Admin') || Object?.values(userRolesDict)?.includes('INTERNAL') || Object?.values(userRolesDict)?.includes('Internal') || Object?.values(userRolesDict)?.includes('CXO Office') || isDevEnv;
	const keyPressed = useKeyPress();

	const filteredList = useMemo(() => {
		return list?.filter((item) => item.type === 'RECIPE') || [];
	}, [list]);

	const currentIdx = useMemo(() => {
		return filteredList.findIndex((item) => item.id === parseInt(id, 10));
	}, [filteredList, id]);

	useEffect(() => {
		setState({
			activeTab: 0,
			fields: cloneDeep(cookingRecipeConfig.initialState.fields),
		});
		setIsPastVersion(true);
		setPastVersionData(null);
		setPastVersionFields(null);
		setActiveStage(1);
		setProductMappingData([]);
		didAutoFetchPastVersionRef.current = false;
	}, [id]);

	useEffect(() => {
		fetchProduct({
			entity: 'RECIPES',
			req: {
				params: {
					productId: id,
				},
			},
			method: 'VIEW',
		});
		fetchProducts();
		fetchProcessTypesList({
			entity: 'PROCESS_TYPES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchCookingStations({
			entity: 'COOKING_STATIONS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchStoresList({
			entity: 'STORES',
			req: { params: { id: '' } },
			method: 'LIST',
		});
		if (!list || Array.isArray(list) && list?.length === 0) {
			fetchRecipeList({
				entity: 'RECIPES',
				req: {
					params: {
						id: '',
					},
				},
				method: 'LIST',
			});
		}
	}, [id]);

	useEffect(() => {
		fetchProductRecipe({
			entity: 'COOKING_PRODUCT_CONFIG',
			req: {
				params: {
					id,
				},
			},
			method: 'VIEW',
		});
	}, [id]);

	// useEffect(() => {
	// 	setCookingFields(cookingConfig.serializer(cookingFields, recipeData));
	// }, [recipeData]);
	const allIntermediateProducts = useMemo(() => {
		return findAllIntermediateProducts(data);
	}, [data]);

	// A recipe tree counts as "approval pending" if the recipe itself OR any of
	// its child/grandchild recipes is pending. The status pill, the compare
	// toggle default, and the comparison version-resolution all key off this.
	const parentApprovalPending = data?.recipe?.recipeStatus === 'APPROVAL_PENDING';
	const childApprovalPending = useMemo(() => {
		return Object.values(state?.fields?.stages?.items || {}).some(
			(stage) => stage?.recipeData?.recipeStatus === 'APPROVAL_PENDING'
		);
	}, [state?.fields?.stages?.items]);
	const isApprovalPending = parentApprovalPending || childApprovalPending;

	const allPastIntermediateProducts = useMemo(() => {
		const productArr = findAllIntermediateProducts(pastVersionData);
		const pendingComparison = isApprovalPending;
		return productArr.map((item) => {
			const foundItem = Object.values(state?.fields?.stages?.items || {})?.find((ele) => {
				return ele?.stageProduct?.id === item.skuId || ele?.recipeData?.product?.id === item.skuId;
			});
			const currentVersion = foundItem?.recipeData?.version || foundItem?.version;
			const childPending = foundItem?.recipeData?.recipeStatus === 'APPROVAL_PENDING';
			const resolvedVersion = resolveCompareVersion({ currentVersion, childPending, pendingComparison, fallback: item.version });
			return {
				...item,
				version: resolvedVersion,
			};
		});
	}, [pastVersionData, state?.fields?.stages?.items, data?.recipe?.recipeStatus, isApprovalPending]);

	useEffect(() => {
		if (!isEmpty(data)) {
			// Only serialize if the data matches the current route id
			const dataProductId = data?.product?.id ?? data?.recipe?.productId;
			if (dataProductId && String(dataProductId) !== String(id)) return;
			const serializedProductRecipe = cookingRecipeConfig.serializer(
				{ activeTab: 0, fields: cloneDeep(cookingRecipeConfig.initialState.fields) },
				data,
				processTypes
			);
			(async () => {
				const stagesArr = cloneDeep(
					serializedProductRecipe?.fields?.stages
				);
				await depthFirstIntermediates(allIntermediateProducts, {
					...stagesArr,
					stageLevel: 1,
				}, processTypes);
				const { stages, ...remaining } =
					serializedProductRecipe?.fields;
				stagesArr.items['1'] = {
					...stagesArr.items['1'],
					recipeData: remaining,
				};
				serializedProductRecipe.fields.stages = stagesArr;
				setState(serializedProductRecipe);
				setActiveStage(1);
				setActiveProcess(
					serializedProductRecipe.fields.stages.items[1]?.processes.order.length ?? -1
				);
			})();
		}
	}, [data, processTypes]);

	// Set default mapping store
	useEffect(() => {
		if (!selectedMappingStoreId && storesList?.length > 0) {
			const baseStore = storesList.find((s) => s?.type === 'BASE');
			if (baseStore?.id) {
				setSelectedMappingStoreId(baseStore.id);
				fetchBatches(baseStore.id);
			}
		}
	}, [storesList]);

	const handleMappingStoreChange = (value) => {
		setSelectedMappingStoreId(value);
		fetchBatches(value);
	}
	// Fetch product-wise mapping data
	useEffect(() => {
		const fetchMappingData = async () => {
			if (!selectedMappingStoreId) return;
			const productIds = Object.values(state?.fields?.stages?.items)
				?.map((item) => item?.stageProduct?.id)
				?.filter(Boolean);
			if (!productIds?.length) return;
			try {
				const response = await productProcessMapServices.fetchProductWiseMappingData({
					data: {
						store: { id: selectedMappingStoreId },
						mappingTypes: MAPPING_TYPE_CONFIG.map((c) => c.mappingId),
						categoryId: null,
						products: productIds,
					},
				});
				if (response?.responseCode === 'SS-001') {
					setProductMappingData(response?.data?.productwiseMappings ?? []);
				}
			} catch (error) {
				console.error('Error fetching product mapping data:', error);
			}
		};
		fetchMappingData();
	}, [selectedMappingStoreId, state?.fields?.stages?.items]);



	// Update stage processes based on mappings
	useEffect(() => {
		setState((prevState) => {
			const updatedItems = cloneDeep(prevState.fields.stages.items);
			let hasUpdates = false;

			Object.keys(updatedItems).forEach((key) => {
				const stage = updatedItems[key];
				const productId = stage?.stageProduct?.id;
				if (productId) {
					// Find mapping for this product with type 1 (Process)
					const mapping = productMappingData.find(
						(m) => m.productId === productId && m.mappingTypeId === 1
					);
					if (mapping) {
						const processId = Number(mapping.mappingTypeElementValue);
						const foundProcess = processTypes.find((p) => p.id == processId);
						if (foundProcess) {
							const newProcess = {
								...foundProcess.data,
								id: foundProcess.id,
								heading: mapping.mappingTypeElement || foundProcess.data.heading,
							};
							if (stage.process?.id !== newProcess.id || stage.process?.heading !== newProcess.heading) {
								stage.process = newProcess;
								hasUpdates = true;
							}
						}
					} else {
						const warningText = 'Factory Yield Capture Layout Not Mapped';
						if (stage.process?.heading !== warningText) {
							stage.process = {
								...stage.process,
								heading: warningText,
								color: '#D83838',
							};
							hasUpdates = true;
						}
					}
				}
			});

			if (!hasUpdates) return prevState;

			return {
				...prevState,
				fields: {
					...prevState.fields,
					stages: {
						...prevState.fields.stages,
						items: updatedItems,
					},
				},
			};
		});
	}, [productMappingData, processTypes]);

	// Get mappings for the active stage product
	const activeStageMappings = useMemo(() => {
		const productId = state?.fields?.stages?.items?.[activeStage]?.stageProduct?.id;
		if (!productId) return [];
		return productMappingData?.filter((m) => m?.productId === productId) ?? [];
	}, [productMappingData, activeStage, state?.fields?.stages?.items]);

	const { activeTab, fields } = state;
	const variants = fields?.product?.variants || [];

	const handleTabChange = (event, tab) => {
		setState({
			...state,
			activeTab: tab,
		});
	};

	const totalRecipeCookingTime = useMemo(() => {
		let totalTimeRequired = 0;
		Object.values(state?.fields?.stages?.items)?.forEach((stageValue) => {
			Object.values(stageValue?.processes?.items)?.forEach(
				(processValue) => {
					totalTimeRequired += processValue?.time;
				}
			);
		});
		return totalTimeRequired;
	}, [state?.fields]);

	const nutrientInfo = useMemo(() => {
		const product = fields?.product || {};
		const variant = product?.variants?.[0] || {};
		const unit = product?.unit?.toLowerCase() || '';
		const isGrm = unit === 'gram' || unit === 'grm' || unit === 'gm' || unit === 'g';
		const isCount = unit === 'count' || unit === 'pc' || unit === 'pcs' || unit === 'piece';
		const perLabel = isGrm ? 'per 100g' : (isCount ? 'per 100 pc' : `per ${unit}`);

		const getNutrientValue = (key) => {
			const val = variant?.[key] ?? product?.[key] ?? 0;
			return Number(val);
		};

		const nutrients = [
			{ label: 'Calories', value: getNutrientValue('Calories'), unit: 'Kcal' },
			{ label: 'Protein', value: getNutrientValue('Protein'), unit: 'g' },
			{ label: 'Carbs', value: getNutrientValue('Carbs'), unit: 'g' },
			{ label: 'Fat', value: getNutrientValue('Fat'), unit: 'g' },
			{ label: 'Calcium', value: getNutrientValue('Calcium'), unit: 'mg' },
		];

		return { perLabel, nutrients };
	}, [fields?.product]);

	// Serialize past version data when available (pastVersionFields state is
	// declared near the top of the component alongside the other version state).
	useEffect(() => {
		if (!isPastVersion || !pastVersionData || !data || !processTypes) {
			setPastVersionFields(null);
			return;
		}
		const initialState = {
			activeTab: 0,
			fields: cloneDeep(cookingRecipeConfig.initialState.fields),
		};
		(async () => {
			try {
				const serializedPast = cookingRecipeConfig.serializer(
					initialState,
					pastVersionData,
					processTypes
				);
				const stagesArr = cloneDeep(serializedPast?.fields?.stages);
				const pendingComparison = isApprovalPending;
				await depthFirstIntermediates(allPastIntermediateProducts, {
					...stagesArr,
					stageLevel: 1,
				}, processTypes, undefined, 0, state.fields.stages.items, pendingComparison);

				const { stages, ...remaining } = serializedPast?.fields;
				stagesArr.items['1'] = {
					...stagesArr.items['1'],
					recipeData: remaining,
				};
				serializedPast.fields.stages = stagesArr;
				setPastVersionFields(serializedPast?.fields || null);
			} catch (err) {
				console.error('Error serializing past version:', err);
				setPastVersionFields(null);
			}
		})();
	}, [isPastVersion, pastVersionData, data, processTypes, allPastIntermediateProducts, isApprovalPending]);

	const renderInfo = (idx) => {

		switch (idx) {
			case 0:
				return (
					<>
						<GeneralDetails fields={fields} />
						{/* <ProductCookingConfig
							isDisable
							fields={cookingFields?.fields}
						/> */}
						<div className='bg-white border border-gray-200 rounded-lg p-4 m-4'>
							<h3 className='text-lg font-semibold mb-3 text-gray-800'>
								Nutrient Info <span className='text-sm font-normal text-gray-500'>({nutrientInfo.perLabel})</span>
							</h3>
							<div className='grid grid-cols-5 gap-4'>
								{nutrientInfo.nutrients.map((nutrient) => (
									<div key={nutrient.label} className='text-center p-3 bg-gray-50 rounded-lg'>
										<div className='text-sm text-gray-500'>{nutrient.label}</div>
										<div className='text-xl font-bold text-gray-800'>
											{nutrient.value}
											<span className='text-sm font-normal text-gray-500 ml-1'>{nutrient.unit}</span>
										</div>
									</div>
								))}
							</div>
						</div>
						<div className='mt-2 mb-10 w-full m-auto border border-slate-600' />
						<CookingRecipeStages
							fields={fields}
							setActiveStage={setActiveStage}
							activeStage={activeStage}
							cookingRecipeConfig={cookingRecipeConfig}
							activeProcess={activeProcess}
							setActiveProcess={setActiveProcess}
							totalRequiredTime={totalRecipeCookingTime}
							activeStageMappings={activeStageMappings}
							mappingTypeConfig={MAPPING_TYPE_CONFIG}
							storesList={storesList?.filter(s => s?.type === 'BASE')}
							selectedMappingStoreId={selectedMappingStoreId}
							onMappingStoreChange={handleMappingStoreChange}
							batches={batches}
							versionDiff={pastVersionFields}
							swapDiffDirection={
								isApprovalPending
								&& isPastVersion
								&& !!pastVersionFields
							}
						/>
					</>
				);
			default:
				return <></>;
		}
	};

	const { url } = useRouteMatch();

	const redirectToEdit = () => {
		const splitURL = url.split('/view');
		splitURL.splice(1, 0, '/edit');
		const newURL = splitURL.join('');
		history.push(newURL);
	};

	const handleStatus = (dataObj) => {
		const submitStatus = async (isReject) => {
			const notificationId = notificationServices?.generateNotification({
				type: 'loading',
				message: 'loading...'
			});
			try {
				const response = await cookingRecipesServices.recipeStatusUpdate({
					data: {
						productId: dataObj?.id,
						recpieId: dataObj?.recipeId,
						...(isReject && { reject: true }),
					}
				});
				if (response?.statusCode === 200) {
					notificationServices?.generateNotification({
						type: 'success',
						message: isReject
							? 'Recipe Rejected Successfully'
							: 'Recipe Approved Successfully',
						config: {
							id: notificationId,
						}
					});
					props.toggleAlert(false);
					setPastVersionData(null);
					setPastVersionFields(null);
					setIsPastVersion(!!isReject);
					didAutoFetchPastVersionRef.current = false;
					props.fetchProduct({
						entity: 'RECIPES',
						req: {
							params: {
								productId: id,
							},
						},
						method: 'VIEW',
					});
				}
			} catch (error) {
				notificationServices?.generateNotification({
					type: 'error',
					message: error || (isReject ? 'failed Rejection' : 'failed Approval'),
					config: {
						id: notificationId,
					}
				});
			}
		};

		props.toggleAlert(true, {
			heading: 'Approve or Reject Recipe',
			message: `Do you want to approve or reject the recipe of "${dataObj?.productName}"?`,
			confirmText: 'Approve',
			cancelText: 'Reject',
			colorReverse: true,
			handleConfirm: () => submitStatus(false),
			handleCancel: () => submitStatus(true),
		});
	};

	const handleVersionToggle = async (checked) => {
		setIsPastVersion(checked);
		if (checked) {
			// Parent is approved but a descendant is pending: the parent itself is
			// unchanged, so compare against the current parent recipe. The pending
			// descendants resolve to their own pending versions in the past tree
			// (pendingComparison === isApprovalPending), surfacing their changes.
			if (!parentApprovalPending && childApprovalPending) {
				setPastVersionData(data);
				return;
			}

			const currentVersion = data?.recipe?.version;
			const canFetch = parentApprovalPending
				? !!currentVersion // pending: fetch v + 1 (no lower bound)
				: currentVersion && currentVersion > 1; // approved: fetch v - 1

			if (canFetch) {
				const targetVersion = parentApprovalPending
					? currentVersion + 1
					: currentVersion - 1;
				const loadingMsg = parentApprovalPending
					? 'Loading pending version...'
					: 'loading...';
				const successMsg = parentApprovalPending
					? 'Pending version fetched successfully'
					: 'Past version fetched successfully';
				const errorMsg = parentApprovalPending
					? 'Failed to fetch pending version'
					: 'Failed to fetch past version';

				const notificationId = notificationServices?.generateNotification({
					type: 'loading',
					message: loadingMsg,
				});
				try {
					const response = await cookingRecipesServices.gateway({
						req: {
							params: {
								productId: id,
								version: targetVersion,
							},
						},
						method: 'VIEW',
					});
					if (response?.statusCode === 200) {
						// Guard against empty/null payload — a 200 with no
						// recipe data means the requested sibling version
						// does not actually exist on the backend.
						const hasData = response?.data
							&& (response.data?.recipe || response.data?.product);
						if (hasData) {
							setPastVersionData(response.data);
							notificationServices?.generateNotification({
								type: 'success',
								message: successMsg,
								config: {
									id: notificationId,
								},
							});
						} else {
							notificationServices?.generateNotification({
								type: 'error',
								message: parentApprovalPending
									? 'No pending version available'
									: 'No previous version available',
								config: {
									id: notificationId,
								},
							});
							setIsPastVersion(false);
						}
					} else {
						// Non-200 without a thrown error — surface it instead
						// of leaving the user with no feedback.
						notificationServices?.generateNotification({
							type: 'error',
							message: errorMsg,
							config: {
								id: notificationId,
							},
						});
						setIsPastVersion(false);
					}
				} catch (error) {
					console.error('Error fetching comparison version:', error);
					notificationServices?.generateNotification({
						type: 'error',
						message: errorMsg,
						config: {
							id: notificationId,
						},
					});
					setIsPastVersion(false);
				} finally {
					notificationServices?.closeNotification(notificationId);
				}
			} else {
				notificationServices?.generateNotification({
					type: 'error',
					message: parentApprovalPending
						? 'No pending version available'
						: 'No previous version available',
				});
				setIsPastVersion(false);
			}
		} else {
			setPastVersionData(null);
		}
	};

	useEffect(() => {
		if (didAutoFetchPastVersionRef.current) return;
		if (!isPastVersion) return;
		if (pastVersionData) return; // already fetched
		const dataProductId = data?.product?.id ?? data?.recipe?.productId;
		if (!dataProductId || String(dataProductId) !== String(id)) return;
		const version = data?.recipe?.version;
		if (version == null) return;
		// Wait until the stage tree (incl. intermediates) is built for THIS recipe
		// so childApprovalPending — and therefore isApprovalPending — is accurate
		// before we decide the default toggle state.
		const topStage = state?.fields?.stages?.items?.['1'];
		const stagesLoaded = topStage?.stageProduct?.id != null
			&& String(topStage.stageProduct.id) === String(id);
		if (!stagesLoaded) return;
		didAutoFetchPastVersionRef.current = true;
		if (isApprovalPending) {
			handleVersionToggle(true);
		} else if (version > 1) {
			handleVersionToggle(false);
		} else {
			setIsPastVersion(false);
		}
	}, [data?.product?.id, data?.recipe?.productId, data?.recipe?.version, data?.recipe?.recipeStatus, isPastVersion, pastVersionData, id, isApprovalPending, state?.fields?.stages?.items]);

	useEffect(() => {
		const qcData = filteredList?.[currentIdx] ?? null;
		if (
			(keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
			qcData !== null
		) {
			const newListItem = keyPressHandler(
				keyPressed,
				filteredList,
				currentIdx
			);
			if (newListItem) {
				if (isPastVersion) {
					handleVersionToggle(false);
				}
				history.push({
					pathname: `${urls.EXTENSION}${urls.COOKING_RECIPE}/view/${newListItem.id}`,

				});
			}
		}
	}, [keyPressed]);

	const navigateRecipe = (e) => {
		const { dataset } = inputHelper(e);
		let newListItem = null;
		if (dataset.type === 'next') {
			newListItem = filteredList?.[currentIdx + 1];
		} else {
			newListItem = filteredList?.[currentIdx - 1];
		}

		if (newListItem) {
			if (isPastVersion) {
				handleVersionToggle(false);
			}
			history.push({
				pathname: `${urls.EXTENSION}${urls.COOKING_RECIPE}/view/${newListItem.id}`,
			});
		}
	};

	const headerExtraActions = useMemo(() => {
		// Show APPROVAL_PENDING whenever the recipe OR any of its descendants is
		// pending; otherwise fall back to the recipe's own status (e.g. APPROVED).
		const recipeStatus = isApprovalPending ? 'APPROVAL_PENDING' : data?.recipe?.recipeStatus;
		const productName = fields?.product?.productName;
		const recipeId = data?.recipe?.id;
		const productId = data?.product?.id;

		return (
			<div className='flex items-center gap-4'>
				{(level === 3 || level === 4) && (
					<div className='flex flex-col items-end gap-1'>
						<FormControlLabel
							control={
								<Switch
									checked={isPastVersion}
									onChange={(e) => handleVersionToggle(e.target.checked)}
									size='small'
								/>
							}
							label={
								<span className='text-xs font-medium'>
									{recipeStatus === 'APPROVAL_PENDING'
										? 'Compare Current Recipe with Pending Version'
										: 'Compare Current Recipe with Previous Recipe Version'}
								</span>
							}
						/>
						<div className='flex items-center gap-3 px-1'>
							<div className='flex items-center gap-1'>
								<div className='w-2 h-2 rounded-full bg-amber-500' />
								<span className='text-[10px] text-gray-500 font-medium uppercase tracking-wider'>Changed</span>
							</div>
							<div className='flex items-center gap-1'>
								<div className='w-2 h-2 rounded-full bg-green-500' />
								<span className='text-[10px] text-gray-500 font-medium uppercase tracking-wider'>
									{recipeStatus === 'APPROVAL_PENDING' ? 'Will be Added' : 'New'}
								</span>
							</div>
							<div className='flex items-center gap-1'>
								<div className='w-2 h-2 rounded-full bg-red-500' />
								<span className='text-[10px] text-gray-500 font-medium uppercase tracking-wider'>
									{recipeStatus === 'APPROVAL_PENDING' ? 'Will be Removed' : 'Previous Value / Removed'}
								</span>
							</div>
						</div>
					</div>
				)}
				{recipeStatus && (
					recipeStatus === 'APPROVAL_PENDING' ? (
						<Button
							className='bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-1.5 rounded shadow-sm text-xs transition-colors'
							onClick={() => handleStatus({ id: productId, recipeId, productName })}
						>
							{recipeStatus}
						</Button>
					) : (
						<div className='text-xs font-semibold px-2 py-1 bg-gray-100 text-gray-600 rounded'>
							{recipeStatus}
						</div>
					)
				)}
				{selectedMappingStoreId && (
					<Button
						variant='outlined'
						color='error'
						size='small'
						onClick={handleOpenBomModal}
						style={{ textTransform: 'none' }}
					>
						View Approved BOM
					</Button>
				)}
				<PageNavigation
					navigate={navigateRecipe}
					prev={{
						tooltip: 'Previous Recipe',
						show: currentIdx > 0,
						disabled: currentIdx === 0,
					}}
					current={{
						label: 'Recipe',
						value: id,
						// `id` above is the route param (productId, used to page through
						// filteredList) - not the CookingRecipe row itself. Shown as a
						// sub-line so it's not mistaken for the product id above it.
						subValue: recipeId ? `Recipe ID: ${recipeId}` : null,
					}}
					next={{
						tooltip: 'Next Recipe',
						show: currentIdx >= 0 && currentIdx < filteredList?.length - 1,
						disabled: currentIdx < 0 || currentIdx === filteredList?.length - 1,
					}}
				/>
			</div>
		);
	}, [data, isPastVersion, level, fields, recipeData, filteredList, currentIdx, id, isApprovalPending]);

	return (
		<div
			className='root transition-colors duration-300'
			style={{
				backgroundColor: isPastVersion ? '#fcfcfe' : 'white',
				minHeight: '100vh',
			}}
		>
			<ViewPageHeader
				heading='View Recipe'
				handleEdit={redirectToEdit}
				showEdit={(isConfigAdmin ?? false) && level !== 3}
				showDelete={false}
				extraActions={headerExtraActions}
				breadcrumbs={[
					...breadcrumbs,
					{
						link: '',
						name: `View ${fields.product.productName}`,
					},
				]}
				showBreadcrumbs
				truncate
			/>
			<AlertModal showCloseBtn={false} />
			<Dialog
				open={isBomModalOpen}
				onClose={() => setIsBomModalOpen(false)}
				maxWidth='xl'
				fullWidth
			>
				<DialogTitle style={{ fontWeight: 'bold', color: '#111827' }}>
					View Approved BOM - {fields?.product?.productName}
					{activeRecipeInfo && (
						<span style={{ fontWeight: 400, fontSize: '0.8rem', color: '#6b7280', marginLeft: 8 }}>
							({activeRecipeInfo.ingredients?.length ?? 0} Ingredients)
						</span>
					)}
				</DialogTitle>
				<DialogContent dividers>
					{isBomLoading ? (
						<div className='flex flex-col items-center justify-center py-10 gap-3'>
							<CircularProgress color='error' />
							<span className='text-sm text-gray-500'>Fetching Recipe BOM...</span>
						</div>
					) : bomError ? (
						<div className='text-center py-6 text-red-500 font-medium'>
							{bomError}
						</div>
					) : (
						<div className='flex flex-col gap-4'>
							<div className='flex gap-4 items-end flex-wrap'>
								<div className='flex flex-col gap-1'>
									<span className='text-xs font-medium text-gray-600'>Batch (Variant)</span>
									<div className='inline-flex flex-wrap rounded-md bg-[#FDE6AD] border border-[#00000033] p-0.5 w-fit'>
										{bomData.map((v) => {
											const label = variantLabel(v);
											return (
												<button
													key={v.variantId}
													type='button'
													onClick={() => handleVariantChange(v.variantId)}
													className={`px-3.5 py-2 flex items-center text-sm font-medium rounded-md whitespace-nowrap transition-colors ${
														Number(selectedVariantId) === Number(v.variantId)
															? 'bg-yellow-400 text-black'
															: 'text-gray-700 hover:bg-yellow-300/50'
													}`}
												>
													{label}
												</button>
											);
										})}
									</div>
								</div>

								<TextField
									label='Quantity'
									type='number'
									size='small'
									value={inputQuantity}
									onChange={(e) => setInputQuantity(Math.max(0, Number(e.target.value)))}
									style={{ width: 120 }}
									inputProps={{ min: 0, step: 'any' }}
								/>
								
								{activeRecipeInfo && (
									<div className='text-xs text-gray-500 flex flex-col'>
										<span>
											Base Batch Size: <strong>{activeRecipeInfo.batchSize} {activeRecipeInfo.unit}</strong>
										</span>
										<span>
											No. of Ingredients: <strong>{activeRecipeInfo.ingredients?.length ?? 0}</strong>
										</span>
										<span>
											Total Batch Cost: <strong>₹{activeRecipeInfo.totalBatchCost}</strong>
										</span>
										{/* The recipe's own cost per unit of output — totalBatchCost
										    divided by the batch size, computed server-side against the
										    same normalised unit shown above (gram->kg, ml->ltr). This is
										    the calculated cost of the product the recipe defines, as
										    opposed to the per-ingredient unit costs in the table. */}
										{activeRecipeInfo.totalCostPerUnit != null && (
											<span>
												Cost per Unit:{' '}
												<strong>
													₹{Number(activeRecipeInfo.totalCostPerUnit).toFixed(2)}/
													{activeRecipeInfo.unit}
												</strong>
											</span>
										)}
									</div>
								)}
							</div>

							{adjustedIngredients.length > 0 ? (
								<TableContainer component={Paper} variant='outlined' style={{ marginTop: '1rem', maxHeight: '60vh', overflowY: 'auto' }}>
									<Table size='small' stickyHeader>
										<TableHead className='bg-gray-50'>
											<TableRow>
												{BOM_COLUMNS.map((column) => (
													<TableCell
														key={column.key}
														style={{ fontWeight: 'bold', whiteSpace: 'nowrap', backgroundColor: '#f9fafb' }}
														align={column.numeric ? 'right' : 'left'}
														sortDirection={bomSort.column === column.key ? bomSort.direction : false}
													>
														<TableSortLabel
															active={bomSort.column === column.key}
															direction={bomSort.column === column.key ? bomSort.direction : 'asc'}
															onClick={() => handleBomSort(column.key)}
															sx={{
																// Default MUI behaviour hides the arrow (opacity 0) until hover/active,
																// which reads as "not sortable" - keep it visible on every column.
																'& .MuiTableSortLabel-icon': {
																	opacity: 1,
																},
															}}
														>
															{column.label}
														</TableSortLabel>
													</TableCell>
												))}
											</TableRow>
										</TableHead>
										<TableBody>
											{sortedIngredients.map((ing, idx) => (
												<TableRow key={idx}>
													<TableCell>{ing.productName}</TableCell>
													<TableCell>{ing.variantName || '-'}</TableCell>
													<TableCell align='right'>
														{ing.qty ? Number(ing.qty).toFixed(3) : '-'}
													</TableCell>
													<TableCell align='right' style={{ fontWeight: 'bold', color: '#b91c1c' }}>
														{ing.adjustedQty ? Number(ing.adjustedQty).toFixed(3) : '-'}
													</TableCell>
													<TableCell>{ing.unit}</TableCell>
													<TableCell align='right'>
														{ing.totalCostPerUnit
															? `₹${Number(ing.totalCostPerUnit).toFixed(2)}/${costingUnit(ing.unit)}`
															: '-'}
													</TableCell>
													<TableCell align='right'>
														{ing.totalCost ? `₹${Number(ing.totalCost).toFixed(2)}` : '-'}
													</TableCell>
													<TableCell align='right' style={{ fontWeight: 'bold' }}>
														{ing.adjustedCost ? `₹${Number(ing.adjustedCost).toFixed(2)}` : '-'}
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							) : (
								selectedVariantId && (
									<div className='text-center py-6 text-gray-500 text-sm'>
										No ingredients found for the selected variant recipe.
									</div>
								)
							)}
						</div>
					)}
				</DialogContent>
				<DialogActions>
					{/* Matches every other export in the console - the Excel mark on
					#1d6f42 (ListTable's downloadData, ExcelDownload). The colour is
					inline because no MUI palette entry carries it, and is dropped while
					disabled so the greyed-out state still reads as disabled. */}
					<Button
						variant='contained'
						size='small'
						onClick={handleExportBom}
						disabled={adjustedIngredients.length === 0}
						startIcon={
							<img
								src={excel}
								alt=''
								style={{ height: '1.25rem' }}
							/>
						}
						style={{
							textTransform: 'none',
							...(adjustedIngredients.length > 0 && {
								backgroundColor: '#1d6f42',
								color: '#fff',
							}),
						}}
					>
						Export CSV
					</Button>
					<Button onClick={() => setIsBomModalOpen(false)} color='error'>
						Close
					</Button>
				</DialogActions>
			</Dialog>
			<StyledTabs value={activeTab} onChange={handleTabChange}>
				{TABS.map((tab) => {
					return <StyledTab label={tab} />;
				})}
			</StyledTabs>
			{TABS.map((tab, idx) => {
				return (
					<TabPanel value={activeTab} index={idx}>
						{renderInfo(idx)}
					</TabPanel>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.RECIPES.data.VIEW;
	const { userPermissions, navState } = state.navigation;
	const processTypes = state?.form?.PROCESS_TYPES?.data?.LIST;
	const recipeData = state.form.COOKING_PRODUCT_CONFIG.data.VIEW;
	const { userList } = state?.auth;
	const storesList = state?.form?.STORES?.data?.LIST;
	const batches = state?.analytics?.INGREDIENT_LIST;
	const list = state?.form?.RECIPES?.data?.LIST;
	return {
		userPermissions,
		data,
		processTypes,
		recipeData,
		navState,
		userList,
		storesList,
		batches,
		list,
	};
};

const mapDispatchToProps = {
	fetchProduct: formActions.gateway,
	fetchProducts: productActions.fetchProducts,
	fetchProcessTypesList: formActions.gateway,
	fetchCookingStations: formActions.gateway,
	fetchRecipeList: formActions.gateway,
	fetchProductRecipe: formActions.gateway,
	fetchUserList: authActions?.fetchUserList,
	fetchStoresList: formActions.gateway,
	fetchBatches: analyticsAction.getIngredients,
	toggleAlert: modalActions?.toggleAlert,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CookingRecipeViewPage);
